import { createBrowserClient } from '@supabase/ssr'

let clientInstance: ReturnType<typeof createBrowserClient> | null = null

export function getSupabaseClient() {
    if (clientInstance) {
        return clientInstance
    }

    clientInstance = createBrowserClient(
        process.env.NEXT_PUBLIC_SUPABASE_URL!,
        process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
        {
            cookies: {
                get(name: string) {
                    if (typeof document === 'undefined') return undefined
                    const cookies = document.cookie.split(';')
                    for (const cookie of cookies) {
                        const [key, value] = cookie.trim().split('=')
                        if (key === name) return decodeURIComponent(value)
                    }
                    return undefined
                },
                set(name: string, value: string, options: any) {
                    if (typeof document === 'undefined') return
                    let cookie = `${name}=${encodeURIComponent(value)}`
                    if (options?.maxAge) cookie += `; max-age=${options.maxAge}`
                    if (options?.path) cookie += `; path=${options.path}`
                    if (options?.domain) cookie += `; domain=${options.domain}`
                    if (options?.secure) cookie += '; secure'
                    if (options?.httpOnly) cookie += '; httponly'
                    if (options?.sameSite) cookie += `; samesite=${options.sameSite}`
                    document.cookie = cookie
                },
                remove(name: string, options: any) {
                    if (typeof document === 'undefined') return
                    this.set(name, '', { ...options, maxAge: 0 })
                },
            },
        }
    )

    return clientInstance
}

// Export the same instance for all uses
export const supabase = getSupabaseClient()
export const supabaseClient = supabase
